import { ActionTypes } from '../constants/actionTypes';

const initialState = {
    MRTData: [],
    MRTLoading: false,
    MRTError: false,
    MRTTotalRows: 0,  
    MRTPageIndex: {
    status: ""
    },
    pageIndex: 0,
    selectedRowDetails: {},
ReportMRTData: {
        technicalData: [],
        contractComponentSummary: [],
        firmwareReleaseHistory: [],
      },
      ReportMRTLoading: {
        technicalData: false,
        contractComponentSummary: false,
        firmwareReleaseHistory: false,
      },
      ReportMRTError: {
        technicalData: null,
        contractComponentSummary: null,
        firmwareReleaseHistory: null,
      },
      ReportMRTTotalRows: {
        technicalData: 0,
        contractComponentSummary: 0,
        firmwareReleaseHistory: 0,
      },
    
}

export const mrtTableReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_SORT:
            return {
                ...state,
                sortField: payload.sortField,
                sortDirection: payload.sortDirection,
            }
        case ActionTypes.FETCH_GRID_API_REQUEST:
            return {
                ...state,
                MRTLoading: true,
                MRTError: false
            };
        case ActionTypes.FETCH_GRID_API_SUCCESS:
            return { ...state, MRTData: payload.res, MRTLoading: false, MRTTotalRows: payload.lastRow,MRTError: false };
        case ActionTypes.FETCH_GRID_API_FAILURE:
            return { ...state, MRTLoading: false, MRTError: true, MRTData: [] };
        case ActionTypes.SET_FILTER_PAGE:
            return {...state, 
                MRTPageIndex: {
                    ...state.MRTPageIndex,
                    status: payload
                }}
        case ActionTypes.SET_ROW_DETAILS:
            return {...state, selectedRowDetails: payload}
            
case ActionTypes.FETCH_REPORT_GRID_API_REQUEST:
      return {
        ...state,
        ReportMRTLoading: {
          ...state.ReportMRTLoading,
          [payload.key]: true,
        },
        ReportMRTError: {
          ...state.ReportMRTError,
          [payload.key]: null,
        },
      };
    
    case ActionTypes.FETCH_REPORT_GRID_API_SUCCESS:
      return {
        ...state,
        ReportMRTData: {
          ...state.ReportMRTData,
          [payload.key]: payload.res,
        },
        ReportMRTTotalRows: {
          ...state.ReportMRTTotalRows,
          [payload.key]: payload.lastRow,
        },
        ReportMRTLoading: {
          ...state.ReportMRTLoading,
          [payload.key]: false,
        },
      };
    
    case ActionTypes.FETCH_REPORT_GRID_API_FAILURE:
      return {
        ...state,
        ReportMRTLoading: {
          ...state.ReportMRTLoading,
          [payload.key]: false,
        },
        ReportMRTError: {
          ...state.ReportMRTError,
          [payload.key]: payload.error,
        },
      };
    
        case ActionTypes.RESET_AUDIT_GRID_DATE:
            return {...state, MRTData: initialState.MRTData}
        case ActionTypes.SET_PAGE_INDEX:
            return {...state, pageIndex: payload}
        default:
            return state;
    }
}